import { type Verdict } from '@exam-center/graphql';
import { Label, LabelColor } from '@shared/components';

export const VERDICT_RESULT_COLOR: Readonly<Record<Verdict, LabelColor>> = {
  APPROVED: LabelColor.SUCCESS,
  REJECTED: LabelColor.ERROR,
};

export const VERDICT_RESULT_TEXT: Readonly<Record<Verdict, string>> = {
  APPROVED: 'อนุมัติคำขอ',
  REJECTED: 'ไม่อนุมัติ',
};

interface VerdictResultLabelProps {
  variant: Verdict;
}

export default function VerdictStatusLabel(props: Readonly<VerdictResultLabelProps>) {
  const { variant } = props;

  return (
    <Label
      color={VERDICT_RESULT_COLOR[variant]}
      sx={(theme) => ({
        borderRadius: theme.shape.rounded(1.5),
        p: theme.spacing(1, 3),
      })}
    >
      {VERDICT_RESULT_TEXT[variant]}
    </Label>
  );
}
